import { gql } from '@apollo/client';

export const FILTERED_SP_INTERVENTIONS = gql`
  query FilteredSPInterventions($input: FilterInterventions!) {
    interventions: filteredSPInterventions(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          name
        }
      }
    }
  }
`;
